// extracted by mini-css-extract-plugin
module.exports = {"Feedback-wrapper":"FeedbackRoot_Feedback-wrapper__2ahKO"};